import { PerspectiveCamera, Text, useTexture } from "@react-three/drei";
import QRCode from "qrcode";
import { useMemo } from "react";
import * as THREE from "three";

export function BadgeTexture({
  user = { firstName: "", lastName: "", title: "", qrLink: "" },
  customTexture = null,
}) {
  const planeWidth = 1;
  const textureAspect = 0.7;
  const defaultTexture = useTexture("/images/base7.png");
  const texture = customTexture || defaultTexture;

  // Create QR code texture
  const qrTexture = useMemo(() => {
    const canvas = document.createElement("canvas");
    canvas.width = 256;
    canvas.height = 256;

    // Generate QR code directly on the canvas
    QRCode.toCanvas(
      canvas,
      user.qrLink || `${user.firstName} ${user.lastName}\n${user.title}`,
      {
        width: 256,
        margin: 4,
        errorCorrectionLevel: "H",
        color: {
          dark: "#ffffff",
          light: "#00000000",
        },
      }
    );

    const texture = new THREE.CanvasTexture(canvas);
    texture.needsUpdate = true;
    return texture;
  }, [user.firstName, user.lastName, user.title, user.qrLink]);

  return (
    <>
      <PerspectiveCamera
        makeDefault
        manual
        aspect={1.05}
        position={[0.49, 0.22, 2]}
      />
      <mesh position={[0, 0, 0]}>
        <planeGeometry args={[planeWidth, -planeWidth / textureAspect]} />
        <meshBasicMaterial map={texture} side={THREE.BackSide} />
      </mesh>
      <mesh position={[0.4, 0.38, 1]}>
        <planeGeometry args={[0.1, 0.1]} />
        <meshBasicMaterial
          map={qrTexture}
          transparent={true}
          side={THREE.FrontSide}
        />
      </mesh>
      <group scale={0.2} position={[-0.44, 0.4, 0]}>
        <Text
          color="white"
          fontSize={0.5}
          font="/fonts/Inter-SemiBold.ttf"
          position={[0, 0, 0]}
          rotation={[0, Math.PI, Math.PI]}
          textAlign="left"
          anchorX="left"
        >
          {user.firstName}
        </Text>
        <Text
          color="white"
          fontSize={0.5}
          font="/fonts/Inter-SemiBold.ttf"
          position={[0, -0.6, 0]}
          rotation={[0, Math.PI, Math.PI]}
          textAlign="left"
          anchorX="left"
        >
          {user.lastName}
        </Text>
        <Text
          color="grey"
          fontSize={0.25}
          font="/fonts/Inter-Regular.ttf"
          position={[0.05, -1.2, 0]}
          rotation={[0, Math.PI, Math.PI]}
          textAlign="left"
          anchorX="left"
        >
          {user.title}
        </Text>
      </group>
    </>
  );
}
